'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.StopThePromisePoolError = void 0;
class StopThePromisePoolError extends Error {
}
exports.StopThePromisePoolError = StopThePromisePoolError;
